import React, { useState } from 'react';
import AccountingDocumentTableConfig from './AccountingDocumentTableConfig';
import { toast } from 'react-toastify';
import LightButton from '../../components/button/LightButton';
import { Actions } from '../../../client/Actions';
import FunctionalTableComponent from '../../components/table/FunctionalTableComponent';
import { useLoaderContext } from '../../components/loader/LoaderContext';
import { Button, Modal } from 'react-bootstrap';
import ConfirmButton from '../../components/button/ConfirmButton';
import DivStart from '../../components/div/DivStart';
import AccountingDocumentFormConfig from './AccountingDocumentFormConfig';
import PaymentTransactionFormConfig from '../transactions/PaymentTransactionFormConfig';

const AccountingDocumentComponent = ({ reservationId }) => {
  const [formKey, setFormKey] = useState(Date.now());


  return (
    <>
      <FunctionalTableComponent
        shadow={false}
        key={formKey}
        title={'Dokumenty księgowe'}
        columns={AccountingDocumentTableConfig}
        creationFields={AccountingDocumentFormConfig}
        header={true}
        api={`/accounting-document/reservation/${reservationId}`}
        removable={true}
        editable={true}
        editWithId={true}
        deleteApi={'accounting-document'}
        createApi={'accounting-document'}
        editApi={'accounting-document'}
        deleteModalTitle={'Usunięcie dokumentu'}
        deleteModalDescription={'Czy na pewno chcesz usunąć dokument?'}
        beforeSave={(data) => {
          data.reservationId = reservationId;
          return data;
        }}
        width={12}
      />

    </>
  );
};

export default AccountingDocumentComponent;

